import styled from 'styled-components'

const WalidacjaStyle = styled.section`
  margin: auto;
  height: 756px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${props => props.theme.black4};

  h2 {
    width: 54%;
    text-align: center;
  }

  h1 {
    width: 64%;
    font-size: 36px;
    color: ${props => props.theme.black60};
    margin-bottom: 12px;
    text-align: center;
  }

  .firstButton {
    margin-right: 8px;
  }
`
export default WalidacjaStyle
